import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="py-3 text-center align-items-center mt-4" data-bs-theme="light">
      <div className="container">
        <p className="mb-0 text-center">
          &copy; The Portfolio of Salman Saeed, All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
